// extracted by mini-css-extract-plugin
export default {"textBox":"style_textBox__nFspI","title":"style_title__at-Hv","description":"style_description__UHCcH"};